<template>
  <div class="refugios">
    <nav class="rf-nav">
      <a href="/landing-refugios" class="rf-nav-logo">
        <img :src="`${ASSETS}/logo-refugios.png`" alt="Refugios de Vida – Paz al fin del mundo">
      </a>
      <button
        type="button"
        class="rf-nav-menu"
        :aria-expanded="menuAbierto"
        aria-label="Menú"
        @click="menuAbierto = !menuAbierto"
      >
        ☰
      </button>
      <ul class="rf-nav-links" :class="{ 'rf-nav-links--abierto': menuAbierto }">
        <li v-for="l in enlaces" :key="l.texto">
          <a :href="l.href" :class="{ activo: l.activo }" @click="menuAbierto = false">{{ l.texto }}</a>
        </li>
      </ul>
    </nav>

    <main>
      <p v-if="error" class="rf-estado rf-estado--error">{{ error }}</p>
      <template v-else-if="sitio">
        <rf-inicio v-if="vista === 'inicio'" />
        <rf-regiones v-else-if="vista === 'regiones'" :sitio="sitio" />
        <rf-region v-else-if="vista === 'region'" :region="region" :sitio="sitio" />
        <rf-ficha v-else-if="vista === 'ficha'" :proyecto="proyecto" />
        <rf-mapa v-else-if="vista === 'mapa'" :proyecto="proyecto" :sitio="sitio" />
        <rf-texto v-else :tipo="vista" :sitio="sitio" />
      </template>
    </main>

    <rf-contacto v-if="conContacto" :proyecto="proyecto" />

    <footer class="rf-pie">
      <img :src="`${ASSETS}/logo-refugios-blanco.png`" alt="Refugios de Vida">
      <p v-if="sitio">{{ sitio.direccion }}</p>
    </footer>
  </div>
</template>

<script>
import './refugios.css';
import RfContacto from './RfContacto.vue';
import RfFicha from './RfFicha.vue';
import RfInicio from './RfInicio.vue';
import RfMapa from './RfMapa.vue';
import RfRegion from './RfRegion.vue';
import RfRegiones from './RfRegiones.vue';
import RfTexto from './RfTexto.vue';
import { ASSETS } from './formato';
import { obtenerSitio } from '@/services/refugiosApi';

// Las vistas que llevan el formulario de contacto al final, como en el diseño.
const CON_CONTACTO = ['inicio', 'region'];

export default {
  name: 'LandingRefugios',
  components: { RfContacto, RfFicha, RfInicio, RfMapa, RfRegion, RfRegiones, RfTexto },
  props: {
    vista: { type: String, default: 'inicio' },
    proyecto: { type: Number, default: null },
    region: { type: Number, default: null },
  },
  data() {
    return { ASSETS, sitio: null, error: '', menuAbierto: false };
  },
  computed: {
    conContacto() {
      return CON_CONTACTO.includes(this.vista);
    },
    enlaces() {
      const enProyectos = ['regiones', 'region', 'ficha', 'mapa'].includes(this.vista);
      return [
        { texto: 'Proyectos', href: '/landing-refugios/proyectos', activo: enProyectos },
        { texto: 'Servicios', href: '/landing-refugios/servicios', activo: this.vista === 'servicios' },
        { texto: 'Quiénes Somos', href: '/landing-refugios/quienes-somos', activo: this.vista === 'quienes-somos' },
        { texto: 'Contacto', href: this.conContacto ? '#contacto' : '/landing-refugios#contacto' },
      ];
    },
  },
  async mounted() {
    // El fondo oscuro del tablero queda en body: acá la página es blanca.
    document.body.classList.add('refugios-body');
    try {
      this.sitio = await obtenerSitio();
    } catch (e) {
      this.error = 'No se pudo cargar el sitio. Intenta de nuevo en un momento.';
    }
  },
};
</script>
